<div class="devstroupe-horizontal-navigation-wrapper">

    <ng-container *ngFor="let item of navigation; trackBy: trackByFn">

        <!-- Skip the hidden items -->
        <ng-container *ngIf="(item.hidden && !item.hidden(hiddenoptions)) || !item.hidden">

            <!-- Basic -->
            <ng-container *ngIf="item.type === 'basic'">
                <devstroupe-horizontal-navigation-basic-item
                    class="devstroupe-horizontal-navigation-menu-item"
                    [item]="item"
                    [name]="name"></devstroupe-horizontal-navigation-basic-item>
            </ng-container>

            <!-- Branch: aside, collapsable, group -->
            <ng-container *ngIf="item.type === 'aside' || item.type === 'collapsable' || item.type === 'group'">
                <devstroupe-horizontal-navigation-branch-item
                    class="devstroupe-horizontal-navigation-menu-item"
                    [item]="item"
                    [name]="name"></devstroupe-horizontal-navigation-branch-item>
            </ng-container>

            <!-- Spacer -->
            <ng-container *ngIf="item.type === 'spacer'">
                <devstroupe-horizontal-navigation-spacer-item
                    class="devstroupe-horizontal-navigation-menu-item"
                    [item]="item"
                    [name]="name"></devstroupe-horizontal-navigation-spacer-item>
            </ng-container>

        </ng-container>

    </ng-container>

</div>
